<template>
    <div>
        <timeslots ref="log"
            :log="log"
            :registration="registration"
            :degree="degree"
            :simulation="simulation"
            :session="session"
            :stats="stats"
            :initial-observations="observations"
            :competencies="competencies"
            :types="types"
            :lang="lang"
            :filters="filters"
            :features="features"
            :role="role"
            @filtersChanged="$emit('filtersChanged', $event)"
            @progressChanged="$emit('progressChanged', $event)"
            @visibilityChanged="$emit('visibilityChanged', $event)"
            @observationChanged="$emit('observationChanged', $event)"
            @refresh="$emit('refresh')">
        </timeslots>
    </div>
</template>

<script>
    import Timeslots from './Timeslots'

    export default {

        components: {
            Timeslots
        },

        props: {

            log: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            degree: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                default: null
            },
                        
            stats: {
                type: Object,
                default: null
            },
            
            observations: {
                type: Object,
                default: null
            },

            lang: {
                type: String,
                default: "en"
            },
            
            filters: {
                type: Object,
                default: {}
            },

            features: {
                default: null
            },

            role: {
                type: String,
                default: 'instructor'
            },
        },

        methods: {
            scrollToTimeslot(timeslotId) {
                this.$refs.log.scrollToTimeslot(timeslotId)
            }
        }
    }
</script>
